import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-bsdrop-down',
	templateUrl:'./BSDropDownPage.html',
	styles: [],
	styleUrls:['./BSDropDownPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSDropDownPage
{
	mdContent_102 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.dropdown.BSDropDown;
\`\`\``;
	mdContent_103 = `\`\`\`java
new BSDropDown<>()
\`\`\``;
	mdContent_104 = `\`\`\`java
var dropdown = new BSDropDown<>();
dropdown.setText("Options");
dropdown.addItem("Action");
dropdown.addItem("Another action");
dropdown.addItem("Something else");
\`\`\``;
	mdContent_105 = `\`\`\`java
var dropdown = new BSDropDown<>();
dropdown.setText("Dropup");
dropdown.setPlacement(BSPlacements.Top);
\`\`\``;
}
